<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.lo_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="lo_pleaseman">
            <label class="weui-form-preview__label">{{customLabel.lo_pleaseman || "借款人"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
            >{{form.main.lo_department}} {{form.main.lo_pleaseman}}
            <call-mobile :em-id="form.main.lo_pleasemanid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="lo_class">
            <label class="weui-form-preview__label">{{customLabel.lo_class || "借支类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.lo_class}}</span>
          </div>
          <div class="weui-form-preview__item" slot="lo_receivedby">
            <label class="weui-form-preview__label">{{customLabel.lo_receivedby || "收款人"}}</label>
            <span class="weui-form-preview__value">{{form.main.lo_receivedby}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.lo_bankaccount" slot="lo_bankaccount">
            <label class="weui-form-preview__label">{{customLabel.lo_bankaccount || "收款银行"}}</label>
            <span class="weui-form-preview__value">{{form.main.lo_bank}} {{form.main.lo_bankaccount}}</span>
          </div>
          <div class="weui-form-preview__item" slot="lo_borrowamount">
            <label class="weui-form-preview__label">{{customLabel.lo_borrowamount || "借款金额(元)"}}</label>
            <span
              class="weui-form-preview__value"
            ><span
              v-format="'#,##0.00'"
            >{{form.main.lo_borrowamount}}</span> {{form.main.lo_currency}}</span>
          </div>
          <div class="weui-form-preview__item" slot="lo_content">
            <label class="weui-form-preview__label">{{customLabel.lo_content || "借款用途"}}</label>
            <span class="weui-form-preview__value">{{form.main.lo_content}}</span>
          </div>
          <div class="weui-form-preview__item" slot="lo_date">
            <label class="weui-form-preview__label">{{customLabel.lo_date || "申请日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.lo_date}}</span>
          </div>
          <div class="weui-form-preview__item" slot="lo_predictreturndate">
            <label class="weui-form-preview__label">{{customLabel.lo_predictreturndate || "预计归还日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.lo_predictreturndate}}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.lo_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/loan_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/oa/loan",
      codeField: "lo_code",
      statusField: "lo_statuscode",
      caller: "Loan",
      xtype: "oa-loan-formpanel",
    };
  }
};
</script>